<template>
  <v-container>
    <v-row>
      <v-col
        class="d-flex flex-column align-start ml-4 pl-4 ml-md-16 pl-md-16"
        md="12"
        sm="12"
      >
        <v-img
          class="mx-2 mb-8 mt-16"
          src="/img/vehicle.svg"
          max-width="220"
        ></v-img>

        <h1
          class="text-left text-md-center text-h4 text-md-h3"
          style="color: white; font-family: inherit !important"
        >
          Create Your Business Profile
        </h1>
        <p class="underline-secondary mb-8 mt-8"></p>

        <p
          style="color: white; text-align: left; font-family: inherit !important;"
          class="mb-8 text-left text-h6 text-md-h5"
        >
          Welcome, thanks for joining Timeless Courier. In-order to serve you
          <br />
          better, kindly create A Business Profile for your organisation. It
          <br />
          will only take a few minutes.
        </p>
        <br />
        <v-btn
          rounded
          to="/dashboard/register"
          class="mt-5 mb-5"
          x-large
          color="primary"
          style="color: #fed400; border: 1px solid white !important;"
          >Create Profile</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DashboardStart"
};
</script>

<style>
.v-application .text-h3 {
  font-family: inherit !important;
  font-weight: 600;
}
</style>
